module.exports = __webpack_public_path__ + "img/image63.7f709cfe.jpg";